import React, { useEffect, useState } from "react";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  rowStyleEinv,
  sortCaret,
} from "../Utility/Utility";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import trashImg from "images/trash.png";
import NoData from "../Utility/NoData";
import swal from "sweetalert";
import {
  deleteRow,
  downloadPDFEinv,
  getEinvoiceData,
  getItemListData,
  onCancelIrn,
  sendEmailEinv,
  setGstResTableData,
  setSelected,
  setSelectedRow,
} from "./action";
import ReactPaginate from "react-paginate";
import { downloadPDF, sendEmail, setTableData } from "./action";
import { Button } from "@material-ui/core";
import PdfImage from "images/pdf-svgrepo-com.svg";
import EmailIcon from "@material-ui/icons/Email";
import EmailModal from "./Modals/EmailModal";
import GovtResModal from "./Modals/GovtResModal";
import ItemListModal from "./Modals/ItemListModal";
import moment from "moment";
import GradeOutlinedIcon from "@material-ui/icons/GradeOutlined";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";

const Table = (props) => {
  const dispatch = useDispatch();
  const [ewayEmailData, setEwayEmailData] = useState("");
  const [einvEmailData, setEinvEmailData] = useState("");
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openGovtResModal, setOpenGovtResModal] = useState(false);
  const [openItemModal, setOpenItemModal] = useState(false);
  const [itemError, setItemError] = useState("");

  const {
    tableData,
    searchStr,
    totalRecords,
    totalPages,
    selected,
    gstResTableData,
    checkedIrn,
    checkedCancel,
    checkedIrnNotGen,
    selectedRow
  } = useSelector((state) => state.EinvReducerNew);

  useEffect(() => {
    return () => dispatch(setTableData([]));
  }, []);

  /* Delete handling */
  const handleDeleteRow = async (row) => {
    // console.log("Single delete", [row.txn_id]);
    try {
      if (!row.txn_id) return;

      const willDelete = await swal({
        title: "Are you sure?",
        text: "Do you want to delete record?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (willDelete) {
        await dispatch(deleteRow([row.txn_id]));
        dispatch(
          getEinvoiceData(
            searchStr,
            props.pageNumber,
            checkedIrn === true
              ? 1
              : checkedCancel === true
              ? 2
              : checkedIrnNotGen === true
              ? 3
              : ""
          )
        );
      }
    } catch (err) {
      console.log(`Error in handleDeleteRow: ${err}`);
    }
  };
  const deleteFormatter = (cell, row, rowIndex, formatExtraData) => {
    const isError =
      row?.["0|is_error|is_error"] === 1 || row?.["0|is_error|is_error"] === 2;

    return isError ? (
      "--"
    ) : (
      <Tooltip title="Delete record" placement="right">
        <img
          src={trashImg}
          alt="Delete"
          onClick={() => handleDeleteRow(row)}
          style={{
            width: "23px",
            position: "inherit",
            outline: "none",
            cursor: "pointer",
          }}
        />
      </Tooltip>
    );

    // return (
    //   <>
    //   { row?.["0|is_error|is_error"] === 1 ||
    //             row?.["0|is_error|is_error"] === 2 ? '--' : <Tooltip title="Delete record" placement="right">
    //             <img
    //               src={trashImg}
    //               alt="Delete"
    //               onClick={() => handleDeleteRow(row)}
    //               style={{
    //                 visibility:
    //                   row?.["0|is_error|is_error"] === 1 ||
    //                   row?.["0|is_error|is_error"] === 2
    //                     ? "hidden"
    //                     : "visible",
    //                 width:
    //                   row?.["0|is_error|is_error"] === 1 ||
    //                   row?.["0|is_error|is_error"] === 2
    //                     ? "0px"
    //                     : "23px",
    //                 position: "inherit",
    //                 outline: "none",
    //                 cursor: "pointer",
    //               }}
    //             />
    //           </Tooltip>}

    //   </>
    // );
  };

  const cancelIrn = (data, timeLeft) => {
    if (timeLeft > 0) {
      swalFun(data);
    } else {
      errorToastMessage(COMMON_MSGS.TIME_EXCEEDED_INVOICE);
    }
  };

  const swalFun = (data) => {
    swal({
      title: "Are you sure?",
      text: " Do you want to cancel IRN?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await dispatch(onCancelIrn(data));
        dispatch(
          getEinvoiceData(
            searchStr,
            1,
            checkedIrn === true
              ? 1
              : checkedCancel === true
              ? 2
              : checkedIrnNotGen === true
              ? 3
              : ""
          )
        );
        // props.fetchEinvoiceData();
      }
    });
  };

  const cancelFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (row["0|AckDt|AckDt"] != null && row["0|AckDt|AckDt"] != undefined) {
      var irnTime = row["0|AckDt|AckDt"],
        timeLeft,
        seconds,
        rhours,
        minutes;
      var liveTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      var date1 = moment(`${irnTime}`);
      var date2 = moment(`${liveTime}`);
      var diff = Math.abs(date2.diff(date1));

      var minutes = Math.floor(diff / 60000);

      if (minutes < 1440) {
        timeLeft = 1440 - minutes;
        seconds = timeLeft * 60;

        rhours = Math.floor(seconds / 3600);
        minutes = (seconds / 3600 - rhours) * 60;
      } else {
        seconds = 0;
      }
    }

    let data = {
      irn: row["2|Irn|Irn"],
      txn_id: row["txn_id"],
      supplier_gstin: row["25|SellerDtlsGstin|Supplier_GSTIN"],
    };
    const showCountdown =
      (row["0|SignedQRCode|SignedQRCode"] != null ||
        row["0|is_error|is_error"] == 3) &&
      row["0|is_error|is_error"] != 4 &&
      seconds > 0;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Tooltip
          title={
            timeLeft > 0
              ? `Time Left: ${Math.floor(seconds / 3600)} hrs and ${Math.round(
                  minutes
                )} minutes`
              : "Time Exceeded"
          }
          placement="right"
        >
          <div onClick={() => cancelIrn(data, timeLeft)}>
            {showCountdown ? (
              <CountdownCircleTimer
                isPlaying
                initialRemainingTime={seconds}
                duration={86400}
                size={40}
                strokeWidth={5}
                colors={[["#004777", 0.33], ["#F7B801", 0.33], ["#DE002E"]]}
                trailColor={"darkgrey"}
              >
                {() => Math.floor(seconds / 3600)}
              </CountdownCircleTimer>
            ) : (
              <span>--</span>
            )}
          </div>
        </Tooltip>
        {/* As dicussed with himanshu and mayank on 27.03.2025 At 1:00pm, removing this */}
        {/* {seconds !== 0 && (
        <Tooltip title="Cancel multiple" placement="right">
          <GradeOutlinedIcon
            // onClick={() =>
            //   this.onCancelMultiple(cell, row, rowIndex, formatExtraData)
            // }
            style={
              row["0|SignedInvoice|SignedInvoice"] != null
                ? {
                    position: "inherit",
                    marginLeft: "10px",
                    fontSize: "20px",
                    paddingTop: "3px",
                  }
                : { visibility: "hidden" }
            }
          />
        </Tooltip>
      )} */}
      </div>
    );
    // return (
    //   <div
    //     style={{
    //       display: "flex",
    //       justifyContent: "center",
    //       alignItems: "center",
    //       height: "100%",
    //       width: "100%",
    //     }}
    //   >
    //     <Tooltip
    //       title={
    //         timeLeft > 0
    //           ? `Time Left::${Math.floor(seconds / 3600)} hrs and ${Math.round(
    //               minutes
    //             )} minutes`
    //           : "Time Exceeded"
    //       }
    //       placement="right"
    //     >
    //       <div onClick={() => cancelIrn(data, timeLeft)}>
    //         {(row["0|SignedQRCode|SignedQRCode"] != null ||
    //           row["0|is_error|is_error"] == 3) &&
    //           row["0|is_error|is_error"] != 4 && (
    //             <CountdownCircleTimer
    //               isPlaying
    //               initialRemainingTime={seconds}
    //               duration={86400}
    //               size={40}
    //               strokeWidth={5}
    //               colors={[["#004777", 0.33], ["#F7B801", 0.33], ["#DE002E"]]}
    //               trailColor={"darkgrey"}
    //             >
    //               {({ remainingTime }) => Math.floor(seconds / 3600)}
    //             </CountdownCircleTimer>
    //           )}
    //       </div>
    //     </Tooltip>
    //     {seconds != 0 && (
    //       <Tooltip title="Cancel multiple" placement="right">
    //         <GradeOutlinedIcon
    //           // onClick={() =>
    //           //   this.onCancelMultiple(cell, row, rowIndex, formatExtraData)
    //           // }
    //           style={
    //             row["0|SignedInvoice|SignedInvoice"] != null
    //               ? {
    //                   position: "inherit",
    //                   marginLeft: "10px",
    //                   fontSize: "20px",
    //                   paddingTop: "3px",
    //                 }
    //               : { visibility: "hidden" }
    //           }
    //         />
    //       </Tooltip>
    //     )}
    //   </div>
    // );
  };

  /* PDF Email Handling  */
  const handleEwayPdfDownload = (data) => {
    dispatch(downloadPDF(data));
  };

  const handleEinvPdfDownload = (data) => {
    dispatch(downloadPDFEinv(data));
  };

  const handleEmail = async (data, type) => {
    if (type === "Eway") {
      setEwayEmailData(data);
      setEinvEmailData({});
    } else if (type === "Einv") {
      setEinvEmailData(data);
      setEwayEmailData({});
    }

    setOpenEmailModal(true);
  };

  const handleEmailSubmit = async (data) => {
    setOpenEmailModal(true);

    try {
      if (ewayEmailData && Object.keys(ewayEmailData).length > 0) {
        await dispatch(sendEmail(ewayEmailData, data));
      } else if (einvEmailData && Object.keys(einvEmailData).length > 0) {
        await dispatch(sendEmailEinv(einvEmailData, data));
      } else {
        console.log("All length 0");
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }

    setOpenEmailModal(false);
  };

  const eWayPDFFormatter = (cell, row, rowIndex, formatExtraData) => {
    const data = {
      txn_id: row["txn_id"],
      doc_No: row["5|DocDtlsNo|Document_Num"],
    };
    const emailData = {
      txn_id: row["txn_id"],
    };
    return (
      <>
        {row["0|SignedQRCode|SignedQRCode"] != null &&
        row["-1|isEwayError|isEwayError"] == 1 ? (
          <div style={{display: "flex",justifyContent:'space-evenly',width:'100%'}}>
            {/* <Button
              style={
                row["-1|isEwayError|isEwayError"] == 1
                  ? {
                      position: "inherit",
                      outline: "none",
                    }
                  : { visibility: "hidden", cursor: "auto" }
              }
              onClick={() => handleEwayPdfDownload(data)}
            > */}
              <img style={
                row["-1|isEwayError|isEwayError"] == 1
                  ? {
                      position: "inherit",
                      outline: "none",
                      width:'22px'
                    }
                  : { visibility: "hidden", cursor: "auto" }
              }
              src={PdfImage} 
              alt="PDF"
              onClick={() => handleEwayPdfDownload(data)} />
            {/* </Button> */}
            {/* <Button
              color="secondary"
              onClick={() => handleEmail(emailData, "Eway")}
              style={
                row["-1|isEwayError|isEwayError"] == 1
                  ? {
                      position: "inherit",
                      outline: "none",
                    }
                  : { visibility: "hidden", cursor: "auto" }
              }
            > */}
              <EmailIcon 
              // style={{ fontSize: "18px", color: "#201e1f" }}
              style={
                row["-1|isEwayError|isEwayError"] == 1
                  ? {
                      position: "inherit",
                      outline: "none",
                       fontSize: "18px", color: "#201e1f"
                    }
                  : { visibility: "hidden", cursor: "auto" }
              }
                onClick={() => handleEmail(emailData, "Eway")}/>
            {/* </Button> */}
          </div>
        ) : (
          "--"
        )}
      </>
    );
  };

  const einvPDFFormatter = (cell, row, rowIndex, formatExtraData) => {
    const data = {
      qr: row["0|SignedQRCode|SignedQRCode"],
      txn_id: row["txn_id"],
      ack_dt: row["0|AckDt|AckDt"],
      ack_no: row["0|AckNo|AckNo"],
      irn: row["2|Irn|Irn"],
      status_code: row["0|status_cd|status_cd"],
      is_error: row["0|is_error|is_error"],
      doc_No: row["5|DocDtlsNo|Document_Num"],
    };
    return (
      <>
        {row["0|SignedQRCode|SignedQRCode"] != null ||
        row["3|TranDtlsSupTyp|Supply_Type_Code"] == "B2C" ? (
          <div style={{ display: "flex",justifyContent:'space-evenly',width:'100%' }}>
            {/* <Button
              style={
                row["0|SignedQRCode|SignedQRCode"] != null ||
                row["3|TranDtlsSupTyp|Supply_Type_Code"] == "B2C"
                  ? {
                      position: "inherit",
                      outline: "none",
                    }
                  : { visibility: "hidden" }
              }
              onClick={() => handleEinvPdfDownload(data)}
            > */}
              {/* <img style={{ width: "22px" ,}} src={PdfImage} alt="PDF" /> */}
              <img style={
                row["0|SignedQRCode|SignedQRCode"] != null ||
                row["3|TranDtlsSupTyp|Supply_Type_Code"] == "B2C"
                  ? {
                      // position: "inherit",
                      // outline: "none",
                      width:'22px'
                    }
                  : { visibility: "hidden" }
              } 
              src={PdfImage} 
              alt="PDF"
              onClick={() => handleEinvPdfDownload(data)} />
            {/* </Button> */}
            {/* <Button
              color="secondary"
              onClick={() => handleEmail(data, "Einv")}
              style={{
                position: "inherit",
                outline: "none",
              }}
            > */}
              <EmailIcon style={{ fontSize: "18px", color: "#201e1f" }}  onClick={() => handleEmail(data, "Einv")}/>
            {/* </Button> */}
          </div>
        ) : (
          "--"
        )}
      </>
    );
  };

  const handleGstRes = (row) => {
    try {
      var response;
      if (row["0|is_error|is_error"] == 3) {
        response = row["0|gst_error_response|gst_error_response"];
      } else {
        response = row["0|gst_response|gst_response"];
      }
      dispatch(setGstResTableData(response));
      setOpenGovtResModal(true);
    } catch (err) {
      console.log(`Error in handleGstRes: ${err}`);
    }
  };

  // const gstResFormatter = (cell, row, rowIndex, formatExtraData) => {
  //   return (
  //     <>
  //       <Button
  //         onClick={() => handleGstRes(row)}
  //         style={
  //           row["0|is_error|is_error"] == 1 || row["0|is_error|is_error"] == 2
  //             ? {
  //                 backgroundColor: "cadetblue",
  //                 position: "inherit",
  //                 fontSize: "10px",
  //                 height: "22px",
  //               }
  //             : row["0|is_error|is_error"] == 0 ||
  //               row["0|is_error|is_error"] == 3
  //             ? {
  //                 backgroundColor: "red",
  //                 position: "inherit",
  //                 fontSize: "10px",
  //                 height: "22px",
  //               }
  //             : { visibility: "hidden" }
  //         }
  //       >
  //         <span style={{ color: "#ffffffdb" }}>Msg</span>
  //       </Button>
  //     </>
  //   );
  // };

  const gstResFormatter = (cell, row, rowIndex, formatExtraData) => {
    const errorStatus = row["0|is_error|is_error"];
    let style;
    let showButton = true;

    if (errorStatus === 1 || errorStatus === 2) {
      style = {
        backgroundColor: "cadetblue",
        position: "inherit",
        fontSize: "10px",
        height: "22px",
      };
    } else if (errorStatus === 0 || errorStatus === 3) {
      style = {
        backgroundColor: "red",
        position: "inherit",
        fontSize: "10px",
        height: "22px",
      };
    } else {
      showButton = false;
    }

    return showButton ? (
      <Button onClick={() => handleGstRes(row)} style={style}>
        <span style={{ color: "#ffffffdb" }}>Msg</span>
      </Button>
    ) : (
      <span>--</span>
    );
  };

  const handleItemList = async (row) => {
    try {
      await dispatch(getItemListData(row.txn_id));
      setItemError(row?.is_error);
      // console.log("row?.is_error::", row?.is_error);
      setOpenItemModal(true);
    } catch (error) {
      console.log(`Error in handleItemList ${error}`);
    }
  };

  const itemListFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <Button
          onClick={() => handleItemList(row)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            height: "22px",
            fontSize: "11px",
            textTransform: "capitalize",
          }}
        >
          Items
        </Button>
      </>
    );
  };

  function handleOnSelect(row, isSelect) {
    if (isSelect) {
      dispatch(setSelected([...selected, row.txn_id]));
      dispatch(setSelectedRow([...selectedRow, row]))
    } else {
      let selectedValue = [...selected];
      selectedValue.splice(selectedValue.indexOf(row.txn_id), 1);
      dispatch(setSelected(selectedValue));

      // dispatch(setSelectedRow((selectedRow) => {
      //   let result = selectedRow.filter((x) => x.txn_id !== row.txn_id);
      //   return result;
      // }));
      dispatch(setSelectedRow(selectedRow.filter(x => x.txn_id !== row.txn_id)));
    }
  }

  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.txn_id);
    if (isSelect) {
      dispatch(setSelected(ids));
      dispatch(setSelectedRow(rows))
    }
    else {
      dispatch(setSelected([]));
      dispatch(setSelectedRow([]))
    }
  }

  const columns = [
    // {
    //   dataField: "delete",
    //   text: "Delete",
    //   style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
    //   headerStyle: { ...commonHeaderStyle, width: "3%" },
    //   formatter: deleteFormatter,
    // },
    {
      dataField: "0|gst_response|gst_response",
      text: "GST Response",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "4%" },
      formatter: gstResFormatter,
    },
    {
      dataField: "cancel",
      text: "Cancel IRN",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "4%" },
      formatter: cancelFormatter,
    },

    {
      dataField: "0|eway_response|eway_response",
      text: "E-Invoice PDF",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "4.6%" },
      formatter: einvPDFFormatter,
    },
    {
      dataField: "0|EwbNo|EwbNo",
      text: "EWB PDF",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "4.6%" },
      formatter: eWayPDFFormatter,
    },
    {
      dataField: "0|created_date|created_date",
      text: "Date of Creation",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "6%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "0|created_date|created_date"),
    },
    {
      dataField: "4|DocDtlsTyp|Document_Type_Code",
      text: "Doc Type",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "4|DocDtlsTyp|Document_Type_Code"),
    },
    {
      dataField: "5|DocDtlsNo|Document_Num",
      text: "Doc No.",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "5|DocDtlsNo|Document_Num"),
    },
    {
      dataField: "6|DocDtlsDt|Document_Date",
      text: "Doc Date",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "6|DocDtlsDt|Document_Date"),
    },
    {
      dataField: "25|SellerDtlsGstin|Supplier_GSTIN",
      text: "Supplier GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "25|SellerDtlsGstin|Supplier_GSTIN"),
    },
    {
      dataField: "115|ValDtlsAssVal|Taxable_Value",
      text: "Taxable Value",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "115|ValDtlsAssVal|Taxable_Value"),
    },
    {
      dataField: "116|ValDtlsIgstVal|IGST_Amt",
      text: "IGST",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "116|ValDtlsIgstVal|IGST_Amt"),
    },
    {
      dataField: "117|ValDtlsCgstVal|CGST_Amt",
      text: "CGST",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "117|ValDtlsCgstVal|CGST_Amt"),
    },
    {
      dataField: "118|ValDtlsSgstVal|SGST_Amt",
      text: "SGST",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "118|ValDtlsSgstVal|SGST_Amt"),
    },
    {
      dataField: "119|ValDtlsCesVal|CESS_Amt",
      text: "CESS",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(row, "119|ValDtlsCesVal|CESS_Amt"),
    },
    {
      dataField: "124|ValDtlsTotInvVal|Total_Invoice_Value_INR",
      text: "Invoice Value",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "5%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) =>
        displayNullFormatter(
          row,
          "124|ValDtlsTotInvVal|Total_Invoice_Value_INR"
        ),
    },
    // {
    //   dataField: "0|gst_response|gst_response",
    //   text: "GST Response",
    //   style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
    //   headerStyle: { ...commonHeaderStyle, width: "4%" },
    //   formatter: gstResFormatter,
    // },
    {
      dataField: "0|txn_id|Txn_id",
      text: "Txn ID",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "7%" },
      sort: true,
      sortCaret,
      formatter: (cell, row) => displayNullFormatter(row, "0|txn_id|Txn_id"),
    },
    {
      dataField: "itemList",
      text: "Item List",
      style: (cell, row, rowIndex, colIndex) => ({ ...commonStyle }),
      headerStyle: { ...commonHeaderStyle, width: "4%" },
      formatter: itemListFormatter,
    },
  ];

  const selectRow = {
    mode: "checkbox",
    selected: selected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "2%",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "2%",
      textAlign: "center",
      alignContent: "center",
    },
  };

  return (
    <>
      {tableData?.length > 0 ? (
        <>
          <div id="table-wrapperEinvoice">
            <div id="table-scroll">
              <BootstrapTable
                keyField="0|txn_id|Txn_id"
                data={tableData}
                // keyField='uniqueKey'
                columns={columns}
                rowStyle={rowStyleEinv}
                selectRow={selectRow}
              />{" "}
            </div>
          </div>
          {/* <div
            style={{
              paddingTop: "1em",
              paddingBottom: "1em",
              marginLeft: "1em",
            }}
          >
            <span
              style={{
                fontFamily: "Gt-Walsheim-medium",
              }}
            >
              Total Records:{" "}
              <span
                style={{
                  display: "inline",
                  fontSize: "19px",
                  fontFamily: "Gt-Walsheim-medium",
                }}
              >
                {totalRecords}
              </span>
            </span>
            <br />
          </div> */}
          <br/>
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={props.pageNumber - 1}
            //  initialPage={1}
          />
          <EmailModal
            openEmailModal={openEmailModal}
            setOpenEmailModal={setOpenEmailModal}
            handleEmailSubmit={handleEmailSubmit}
          />
          <GovtResModal
            setOpen={setOpenGovtResModal}
            open={openGovtResModal}
            tableData={gstResTableData}
          />
          <ItemListModal
            openItemModal={openItemModal}
            setOpenItemModal={setOpenItemModal}
            handleItemList={handleItemList}
            itemError={itemError}
          />
        </>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
